import { site } from '@/content/site'
import { cn } from '@/lib/utils'

type BrandNameLockupProps = {
  className?: string
}

export function BrandNameLockup({ className }: BrandNameLockupProps) {
  const [firstWord, ...restWords] = site.name.split(' ')
  const rest = restWords.join(' ')

  return (
    <div className={cn('flex w-full max-w-[62mm] flex-col items-center text-center leading-none', className)}>
      <span
        className="font-brand-serif text-[4.25rem] font-semibold uppercase italic tracking-[0.2em] text-primary"
      >
        {firstWord}
      </span>
      {rest ? (
        <span className="mt-1.5 font-brand-display text-[2.625rem] uppercase tracking-[0.14em] text-primary">
          {rest}
        </span>
      ) : null}
    </div>
  )
}
